import React, { useState } from 'react';

import Icon from 'components/Icon';

import styles from './styles.css';
import cx from 'classnames';

type Option = {
  img?: string;
  value: any;
  label: string;
};

type Props = {
  initValue?: any;
  options: Option[];
  onChange: (value: any) => void;
  customStyles?: any;
};

const Option: React.FC<any> = ({ image, value, label, active, onClick }) => {
  return (
    <div
      className={cx(styles.option, active && styles.selected)}
      onClick={() => onClick && onClick(value)}
    >
      {image && <img src={require(`images/${image}`)} />}
      <label>{label}</label>
    </div>
  );
};

export const Dropdown: React.FC<Props> = ({
  initValue,
  options,
  onChange,
  customStyles,
}) => {
  const [value, setValue] = useState(initValue);
  const [open, setOpen] = useState(false);

  const onClickHandler = (val) => {
    if (val === value) return;
    onChange(val);
    setValue(val);
    setOpen(false);
  };

  const selectedOption = options.find((option) => option.value === value);
  const placeholderOption = { label: 'Placeholder' };

  return (
    <div className={cx(styles.Dropdown)}>
      <div
        className={cx(
          styles.selector,
          open && styles.open,
          !open && customStyles
        )}
        onClick={() => setOpen(!open)}
      >
        {value ? (
          <Option {...selectedOption} />
        ) : (
          <Option {...placeholderOption} />
        )}
        <span className={cx(styles.icon, open && styles.open)}>
          <Icon
            name={open ? 'arrow-up' : 'arrow-down'}
            width={17}
            height={17}
          />
        </span>
      </div>
      {open && (
        <ul className={cx(styles.options)}>
          {options
            .filter((option) => option.value !== selectedOption?.value)
            .map((option, index) => (
              <Option
                key={index}
                {...option}
                active={selectedOption?.value === option.value}
                onClick={onClickHandler}
              />
            ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
